<template>
    <div class="dashboard">
        <div class="dashboard__alert" v-if="alert" @click="alert = false"></div>
        <layout>
            <md-app-content>
                <md-content>
                    <md-progress-spinner v-if="!loaded" :md-stroke="4" md-mode="indeterminate" class="dashboard__spinner"></md-progress-spinner>
                    <orders v-if="loaded"></orders>
                </md-content>
            </md-app-content>
        </layout>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {mapGetters, mapActions} from 'vuex'
    import Orders from '../components/Orders'
    import Layout from '../components/Layout'

    export default {
        name: 'home',
        components: {
            Orders,
            Layout
        },
        data() {
            return {
                alert: false
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
            ...mapGetters('dashboard', [
                'loaded',
                'location',
            ]),
        },
        methods: {
            ...mapActions('dashboard', [
                'loadLocation',
                'togglePaused'
            ]),
            checkAlert() {
                this.alert = false
                if (this.$store.state.idleVue.isIdle) {
                    if (this.location.orders.filter(order => (!order.picked_up && !order.canceled && !order.ready && order.payment_transaction_id)).length > 0) {
                        this.alert = true
                    }
                }
            }
        },
        mounted() {
            setInterval(function () {
                this.checkAlert()
            }.bind(this), 3000)

            setInterval(function () {
                this.loadLocation(this.user.locationId)
            }.bind(this), 30000)

            this.loadLocation(this.user.locationId)
        }
    }
</script>
